import { render } from "./ScbHome.vue?vue&type=template&id=31e86e83&scoped=true&ts=true"
import script from "./ScbHome.vue?vue&type=script&lang=ts"
export * from "./ScbHome.vue?vue&type=script&lang=ts"

import "./ScbHome.vue?vue&type=style&index=0&id=31e86e83&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e86e83"]])

export default __exports__